<div class="main">
    <div class="section">
      <div class="header">
        {{'ACCEPT.accept' | translate}} | # {{parentData.order.load}}
        <i class="material-icons" (click)="closeAcceptModal();">
          clear
        </i>
      </div>
      <div class="bodySection">
    
        <div class="tableSection">
          <table mat-table [dataSource]="acceptArr" class="table" style="width: 97%; margin-left: 10px;">
            <ng-container *ngIf="allocation_type =='vehicle'" matColumnDef="availableVehicles">
              <th mat-header-cell *matHeaderCellDef>{{'ACCEPT.availableVehicles' | translate}}</th>
              <td mat-cell *matCellDef="let element" style="font-size: 32px;"> {{availableNumber}} </td>
            </ng-container>
            <ng-container matColumnDef="allocated">
              <th mat-header-cell *matHeaderCellDef>{{'ACCEPT.allocated' | translate}}
              </th>
              <td mat-cell *matCellDef="let element" style="font-size: 32px;"> {{ parentData.to_be_accepted }} </td>
            </ng-container>
           
            <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
            <tr mat-row *matRowDef="let row; columns: columnsToDisplay;"></tr>
          </table>
        </div>
        <div class="tableSection">
          
                    <!-- <input type="number" [(ngModel)]="acceptNumber" autofocus /> -->
  
          <div class="plan_text">{{'ACCEPT.accept_plan' | translate}}</div>
          <table mat-table [dataSource]="accepted_plan" class="table" style="width: 97%; margin-left: 10px;">
           
            <ng-container matColumnDef="customerName">
              <th mat-header-cell *matHeaderCellDef>{{'ACCEPT.customer_name' | translate}}</th>
              <td mat-cell *matCellDef="let element" style="font-size: 32px;"> {{ element.name }} - {{element.city}} - {{element.locality}} </td>
              <td mat-footer-cell *matFooterCellDef> Total </td>
            </ng-container>
            <ng-container matColumnDef="availableLoad">
              <th mat-header-cell *matHeaderCellDef> {{'ACCEPT.accept_load' | translate}} </th>
              <td mat-cell *matCellDef="let element">
                <div class="full">
                  <div class="right">
                    <!-- {{element.weight}} -->
                    <input type="number" [disabled]="parentData.type=='view'" min="0" [(ngModel)]="element.weight" (keyup)="calTotol()" autofocus />
                  </div>
                </div>
              </td>
              <td mat-footer-cell *matFooterCellDef> {{totalValue}}</td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="columnsToDisplay2"></tr>
            <tr mat-row *matRowDef="let row; columns: columnsToDisplay2;"></tr>
            <tr mat-footer-row *matFooterRowDef="columnsToDisplay2"></tr>
          </table>
          
        </div>
        <div class="submitButton" *ngIf="parentData.type!='view'">
          <div class="button" appDbclick (debounceClick)="accept(acceptNumber)">
            <span>{{'ACCEPT.submit' | translate}}</span>
  
          </div>
        </div>
        <div class="rejectButton"*ngIf="parentData.type!='view'" style="float: left; margin-left: 10px;">
          <div class="button" appDbclick (debounceClick)="accept(0, 'reject')">
            <span>{{'ACCEPT.rejectAll' | translate}}</span>
  
          </div>
  
        </div>
      </div>
    </div>
  </div>